import { ActionIcon, Box, Group, Stack, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../stores/LanguageStore";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import FilterValue from "../valueBlock/FilterValue";
import FilterCondition from "../conditionBlock/FilterCondition";
import FilterField from "../fieldBlock/FilterField";
import { IconTrash } from "@tabler/icons-react";
import { levelsColor } from "../filterSettings";
import FilterModeSelectorMobile from "./FilterModeSelectorMobile";

const booleanCondition = [
  "does_exist",
  "does_not_exist",
  "is_empty",
  "is_not_empty",
  "isEmpty",
  "isNotEmpty",
];

const FilterItemMobile = ({
  item,
  fields,
  handleChange,
  isClient,
  isLast,
  getFieldOptionName,
  handleDelete,
  filterItems,
  levelItems,
  pageName,
  level,
  _mode,
  onModeChange,
  disableEdit,
}) => {
  const lang = useLanguage((s) => s.language);
  const allFields = useMemo(
    () => fields.reduce((acc, group) => [...acc, ...group.options], []),
    [fields]
  );
  const [field, setField] = useState(
    allFields?.find((x) => x?.id?.toString() === item?.field_name)
  );

  useEffect(() => {
    setField(allFields?.find((x) => x?.id?.toString() === item?.field_name));
  }, [allFields, item?.field_name]);

  const [condition, setCondition] = useState(item?.type || "equals");
  const [conditionType, setConditionType] = useState(
    field?.type || field?.conditionType || "text"
  );
  const [value, setValue] = useState(item?.value || "");

  const handleFieldChange = (newValue) => {
    setField(newValue);

    const newValueIsDate =
      newValue?.type === "date" && conditionType !== "date";

    if (newValueIsDate) {
      if (isClient) {
        setCondition("after");
      } else {
        setCondition("contains");
      }
      const actual = dayjs();
      // .set("h", 0)
      // .set("minutes", 0)
      // .set("second", 0)
      // .set("milliseconds", 0);

      setValue(actual.toISOString());

      return setConditionType("date");
    } else if (field?.type !== newValue?.type) {
      if (newValue?.type === "number") {
        setCondition(isClient ? "=" : "equals");
      } else setCondition("equals");
    }

    if (
      (field?.type === "date" ||
        field?.option_name?.toLowerCase().includes("date")) &&
      !newValueIsDate
    ) {
      setValue("");
    }

    if (newValue?.options) {
      setValue(newValue?.options?.[0]?.value);
    } else {
      setValue("");
    }

    if (newValue?.type?.includes?.("exist")) {
      setCondition("does_exist");
      setValue("");
    }

    if (newValue?.type === "date_range") {
      setCondition("between");
      setValue(`${new Date().toISOString()};${new Date().toISOString()}`);
    }

    if (newValue?.type === "contain") {
      setCondition("contains");
      setValue("");
    }

    setConditionType(newValue?.type || newValue?.conditionType || "text");
  };

  useEffect(() => {
    if (handleChange && field?.id) {
      handleChange({
        field_name: field?.id?.toString(),
        type: condition,
        value: value?.toString() || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field, condition, value]);

  return (
    <Group wrap="nowrap" pos={"relative"}>
      {!isLast && (
        <FilterModeSelectorMobile
          onChange={onModeChange}
          value={_mode}
          borderColor={levelsColor[level]}
          disabled={disableEdit}
          level={level}
        />
      )}
      <Stack
        gap={"xs"}
        pos={"relative"}
        ml={46}
        mb={6}
        wrap="nowrap"
        style={{
          border: "1px solid",
          borderColor: levelsColor[0],
          borderRadius: 8,
        }}
        p={"xs"}
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: -32,
            width: 32,
            height: 0,
            borderTop: "1px solid",
            borderColor: levelsColor[0],
          }}
        />

        <FilterField
          field={field}
          fields={fields}
          handleFieldChange={handleFieldChange}
          getFieldOptionName={getFieldOptionName}
          isMobile
        />

        {!field?.disabledCondition && (
          <FilterCondition
            isClient={isClient}
            type={field?.conditionType || conditionType}
            value={condition}
            setValue={setCondition}
            disabled={field?.disabledCondition}
            withOptions={!!field?.options}
            noExists={!!field?.noExists}
            filterValue={value}
            isMobile
          />
        )}

        {!booleanCondition.includes(condition) && (
          <FilterValue
            key={conditionType}
            value={value}
            setValue={setValue}
            label={field?.option_name}
            type={conditionType}
            valueOptions={field?.options}
            getter={field?.getter}
            responseField={field?.responseField}
            storeKey={field?.storeKey}
            setStoreKey={field?.setStoreKey}
            nameField={field?.nameField}
            groups={field?.groups}
            singleSelectOptions={field?.valueOptions}
            filterItems={filterItems}
            field_name={field?.id}
            handleResponse={field?.handleResponse}
            setCondition={setCondition}
            pageName={pageName}
            free={field?.free}
            isMobile
          />
        )}
      </Stack>
      <Tooltip
        label={lang.table.toolbar.filter.conditions.delete_condition_tooltip}
      >
        <ActionIcon color="red" variant="subtle" onClick={handleDelete}>
          <IconTrash size={18} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
};

export default FilterItemMobile;
